module.exports = __webpack_public_path__ + "img/discord.cd59efbc.svg";